import { stateActions } from '../slices/state';
import { dataActions }  from '../slices/data';
import { formActions }  from '../slices/forms';

const Actions = { ...stateActions, ...dataActions, ...formActions };

export default Actions;
